// Station ausgesetzt (z. B. Regen), je Kategorie – Gegenstueck zu
// functions/services/ausgesetzt.js. Kinder und Erwachsene werden getrennt
// gewertet, deshalb gilt das Aussetzen auch nur fuer die jeweilige Gruppe.

/** Ist die Station fuer diese Kategorie ("Kinder" | "Erwachsene") ausgesetzt? */
export function istAusgesetzt(station, kategorie) {
  if (kategorie === "Kinder") return station?.ausgesetzt_kinder === true;
  if (kategorie === "Erwachsene") return station?.ausgesetzt_erwachsene === true;
  return false;
}

/** Fuer mindestens eine Kategorie ausgesetzt? */
export const teilweiseAusgesetzt = (station) =>
  station?.ausgesetzt_kinder === true || station?.ausgesetzt_erwachsene === true;

/** Fuer welche Gruppen? "Kinder", "Erwachsene" oder "Kinder und Erwachsene". */
export function ausgesetztText(station) {
  const k = station?.ausgesetzt_kinder === true;
  const e = station?.ausgesetzt_erwachsene === true;
  if (k && e) return "Kinder und Erwachsene";
  if (k) return "Kinder";
  if (e) return "Erwachsene";
  return "";
}
